const regexFileName = (input) => {
  const fileName = input.match(/(?:[\w\d\-\.](?!\/))+$/) ?? "";
  return fileName[0];
};

export { regexFileName };
//# sourceMappingURL=regexFileName.esm.js.map
